
const $el = $(el);
const $slider       = $el.find('.slider');
const $prev         = $el.find('.slick-prev');
const $next         = $el.find('.slick-next');
const $sliderDots   = $el.find('.slider-dots');

$slider.slick({
    slidesToScroll: 3,
    slidesToShow: 3,
    infinite: false,
    arrows: true,
    dots: true,
    prevArrow: $prev,
    nextArrow: $next,
    appendDots: $sliderDots,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToScroll: 2,
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToScroll: 1,
                slidesToShow: 1,
            }
        },
   ]
});
